<template>
  <div class="delwkjq-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    align="center"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="预付款时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.subsist_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="总报价"
                    width="130"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.amount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="余款"
                    align="center"
                    width="130"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#F56C6C">{{scope.row.balance}}</span>
                    </template>
                  </el-table-column>
                  <!--<el-table-column
                    width="120"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-money" @click.stop="subsist(scope.row)">立即结清</el-button>
                    </template>
                  </el-table-column>-->
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="订单扣款"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules" v-loading="offerinfoLoading" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="报价详情" prop="offerdetail">
          <el-card shadow="hover" style="font-size: 12px;color:#606266">
            <div>
              <span style="color:#99a9bf">报价员：</span>
              <span>{{editForm.offername}}</span>
              <span style="color:#99a9bf;margin-left: 20px">报价时间：</span>
              <span>{{editForm.offertime}}</span>
            </div>
            <div style="">
              <span style="color:#99a9bf">报价单：</span>
              <span><el-button type="text" @click="downOffer" icon="el-icon-download" title="点击下载报价单">{{editForm.offerfile}}</el-button></span>
            </div>
            <div>
              <span style="color:#99a9bf">总报价：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.amount}}</span>元
              <s v-if="offerinfo.amount!==offerinfo.totalprice" style="margin-left: 10px;color:#999;">{{offerinfo.totalprice}}</s>
              <el-tag type="danger" :disable-transitions="true" size="mini" style="margin-left: 10px" v-if="offerinfo.discount>0">{{offerinfo.discount}} 折</el-tag>
            </div>
            <div v-if="offerinfo.factorycom>0||offerinfo.designcom>0">
              <span style="color:#99a9bf;">设计承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.designcom}}</span>元
              <span style="color:#99a9bf;margin-left: 20px">工厂承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.factorycom}}</span>元
              <span style="color:#99a9bf;margin-left: 20px">客户承担：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.clientcom}}</span>元
            </div>
            <div>
              <span style="color:#99a9bf">已收款：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.paidfor}}</span>元
              <span style="color:#99a9bf;margin-left: 20px">余款：</span>
              <span style="color:#F56C6C;font-size: 14px;font-weight: bold;margin-right: 6px">{{offerinfo.balance}}</span>元
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="账户余额" v-if="offerinfo.balance>0">
          <span style="color:#F56C6C;font-size: 16px;font-weight: bold;margin-right: 6px">{{offerinfo.accamount}}</span>元
          <span style="color:#99a9bf">（{{offerinfo.accname}}）</span>
        </el-form-item>
        <el-form-item label="扣款金额" prop="money" v-if="offerinfo.balance>0">
          <el-input v-model="editForm.money" :disabled="true" style="width: 200px">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="content">
          <el-input type="textarea" v-model="editForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即结清尾款</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getDealerBalanceList } from '@/api/dealer'
import { getUser } from '@/utils/auth'
import { getErpOrderOfferDetail, getDebitSMSCode, deductBalance } from '@/api/erp'
import { getFileInfo } from '@/api/pub'
import { getDealerTelList } from '@/api/work'

export default {
  name: 'delwkjq',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      isDisabledCode: true,
      isCodeLoading: false,
      codeBtn: '获取验证码',
      codeTimer: '',
      sounds: 60,
      editForm: {
        orderid: '',
        ordername: '',
        content: '',
        offername: '',
        offertime: '',
        offerfile: '',
        offerfileid: '',
        money: null,
        dedutel: '',
        msg_id: '',
        code: '',
        accid: null,
        deposit: 0,
        accamount: 0
      },
      offerinfoLoading: false,
      offerinfo: [],
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        money: [{ required: true, message: '请输入扣款金额', trigger: 'blur' }],
        dedutel: [{ required: true, message: '请选择扣款验证号码', trigger: 'change' }],
        code: [{ required: true, message: '请输入六位短信验证码', trigger: 'blur' }]
      },
      DealerTelList: []
    }
  },
  created() {
    this.getData()
  },
  watch: {
    'editForm.dedutel': function(newVal) {
      if (newVal !== null && newVal !== '' && newVal !== undefined) {
        if (this.sounds === 60) {
          this.isDisabledCode = false
        }
      } else {
        this.isDisabledCode = true
      }
    }
  },
  methods: {
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        delid: this.user.delid
      }
      getDealerBalanceList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/delorder/' + row.order_id })
    },
    downOffer() {
      getFileInfo({ fileid: this.editForm.offerfileid }).then(response => {
        /* this.$message({
          message: '报价单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getCode() {
      if (this.editForm.dedutel !== null && this.editForm.dedutel !== '' && this.editForm.dedutel !== undefined) {
        if (this.editForm.deposit > 0) {
          if (this.editForm.money !== null && parseFloat(this.editForm.money) > 0) {
            if (parseFloat(this.editForm.money) <= parseFloat(this.editForm.accamount)) {
              if (parseFloat(this.editForm.money) >= parseFloat(this.editForm.deposit)) {
                if (!this.isDisabledCode) {
                  if (this.sounds === 60) {
                    this.isCodeLoading = true
                    const arr = this.editForm.dedutel.split('@')
                    const data = {
                      verifyCode: '1434619f6b1b490fc7b225e6c052abd3',
                      opertype: 0,
                      userid: this.user.userid,
                      type: 0,
                      dataid: this.editForm.orderid,
                      amount: this.editForm.money,
                      phoneNum: arr[1],
                      receiver: arr[0]
                    }
                    getDebitSMSCode(data).then(response => {
                      this.editForm.msg_id = response.data
                      this.isCodeLoading = false
                      this.isDisabledCode = true
                      this.codeTimer = setInterval(this.countdown, 1000)
                    }).catch(() => {
                      this.isCodeLoading = false
                    })
                  } else {
                    this.isDisabledCode = true
                  }
                }
              } else {
                this.$message.error('扣款金额至少为 ' + this.editForm.deposit + ' 元')
              }
            } else {
              this.$message.error('账户余额不足')
            }
          } else {
            this.$message.error('请输入扣款金额')
          }
        } else {
          this.$message.error('预付款为0元，无需扣款')
        }
      } else {
        this.$message.error('请选择扣款验证手机号码')
      }
    },
    countdown() {
      this.sounds--
      if (this.sounds === 0) {
        clearInterval(this.codeTimer)
        this.codeBtn = '获取验证码'
        this.isDisabledCode = false
        this.sounds = 60
      } else {
        this.codeBtn = '重新获取 ' + this.sounds
      }
    },
    subsist(row) {
      this.editRules.content[0].required = false
      this.isDisabledCode = true
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.offername = row.offername
      this.editForm.offertime = row.offer_time
      this.editForm.offerfile = row.offer_filename
      this.editForm.offerfileid = row.offer_fileid
      this.offerinfo = []
      this.editForm.money = null
      this.editForm.accid = null
      this.editForm.dedutel = ''
      this.editForm.msg_id = ''
      this.editForm.code = ''
      this.editForm.deposit = 0
      this.editForm.accamount = 0
      this.editVisible = true
      this.offerinfoLoading = true
      getDealerTelList({ delid: row.delid, page: 1, limit: 9999999 }).then(response => {
        this.DealerTelList = response.data
      }).catch(() => {})
      getErpOrderOfferDetail({ orderid: row.order_id }).then(response => {
        this.offerinfo = response.data
        this.editForm.deposit = this.offerinfo.balance
        this.editForm.money = this.editForm.deposit
        this.editForm.accamount = this.offerinfo.accamount
        this.editForm.accid = this.offerinfo.accid
        this.offerinfoLoading = false
      }).catch(() => {
        this.offerinfoLoading = false
      })
    },
    subEdit(formName) {
      this.editRules.content[0].required = false
      this.editRules.money[0].required = true
      this.editRules.dedutel[0].required = true
      this.editRules.code[0].required = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.userid,
              orderid: this.editForm.orderid,
              remark: this.editForm.content,
              pay: this.editForm.money,
              code: this.editForm.code,
              msg_id: this.editForm.msg_id,
              type: 0,
              msgSwitch: this.offerinfo.msgSwitch
            }
            deductBalance(data).then(response => {
              this.$message({
                message: '订单尾款已结清',
                type: 'success'
              })
              this.editloading = false
              this.editVisible = false
              this.sounds = 60
              if (this.codeTimer !== null && this.codeTimer !== '' && this.codeTimer !== undefined) {
                clearInterval(this.codeTimer)
                this.codeTimer = ''
                this.codeBtn = '获取验证码'
                this.isDisabledCode = true
              }
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.delwkjq-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
